export default "__VITE_ASSET__Yt0mTDpt__"